import React, { useEffect, useState } from "react";
import { useParams,Link, useLocation, useNavigate } from 'react-router-dom';
import "./sangam.css";
import { useDispatch, useSelector } from "react-redux";
import ModalPopupSingle from "./singlePopup";
import axios from "axios";
import { API_BASE_URL,checkTime } from "../constant/constant";
import { msgPromtsuccess,loaderActionSlice,update_user_bal } from "../features/userSlice";
import IconWithRoundedBorder from "./borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";



const SingleGame = () => {
    
    
      
      
      const [rows, setRows] = useState([]);
      const today = new Date();
      const dispatch=useDispatch();
      const navigate=useNavigate();
      const { gameName,gameType } = useParams(); // Access the dynamic parameter
      const [gameNumber,setGameNumber]=useState('');
      const [isModalOpen, setIsModalOpen] = useState(false);
      const formattedDate = (today.getMonth() + 1).toString().padStart(2, '0') + '/' + today.getDate().toString().padStart(2, '0') + '/' + today.getFullYear();
      const location = useLocation();
      const [selectedPoint, setSelectedPoint] = useState('');
      const {Info,all_games}=useSelector((state)=>state.users);
    const [session, setSession] = useState('Open');
    const [sessionval, setSessionval] = useState({
            'Open':'OPEN',
            'Close':'CLOSE',
    });
      // Extract the last segment from the URL
      const lastSegment = location.pathname.split("/").filter(Boolean).pop();


     

      useEffect(()=>{
              let validate=false;
              all_games?.map((value)=>{
                  if(value?.games_name.split(' ').join('_') === gameName){
                      validate=checkTime(value?.open_time);
                  }
              })
              if(!validate){
                  let newData={...sessionval};
                  delete newData['Open'];
                  setSession('Close');
                  setSessionval(newData);
              }
          },[]);


      
     
      const  sumOfDigits=(number)=> {
        return number
          .toString() // Convert number to string
          .split("") // Split string into individual digits
          .map(Number) // Convert each character back to a number
          .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
      }
      function convertToThreeDigits(number) {
        return number.toString().padStart(3, "0");
      }
    
      
      const closeModal = () => {
        setIsModalOpen(false);
      };
    
      const handleDelete = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
      };
      
      const toTitleCase=(str)=>{
        return str
          .toLowerCase() // Convert the entire string to lowercase
          .split(/\s+/) // Split the string by spaces
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
          .join(" "); // Join the words back together with a single space
      }


      const gameMainLogin=(key)=>{
        if(gameType==='single_digit'){
            let closes=(session==='Close')?true:false;
             return {
                'open_pana':'NA',
                'open_digit':closes?'NA':key||'0',
                'close_pana':'NA',
                'close_digit':closes?key:'NA',
             }
        }else if(gameType==='jodi_digit'){
            const digits = key.toString().split("").map(Number);
            return {
                'open_pana':'NA',
                'open_digit':digits[0]||'0',
                'close_pana':'NA',
                'close_digit':digits[1] || '0',
             }
        }else if(gameType==='single_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }
        }else if(gameType==='double_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }

        }else if(gameType==='triple_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }

        }
    }


      const handleSubmit = async() => {
              dispatch(loaderActionSlice(true));
              let remain_ammount=false;
              let userAccountZero=false;
              let isError=false;
              let array=[...rows];
               await [...rows].reduce(async (previousPromise, key,index) => {
                
                  // Wait for the previous request to finish
                  await previousPromise;
                      let myDigits=gameMainLogin(key.sangam);
                    let dataObject={
                        'phone_number':Info?.phone_number,
                        'game_name':toTitleCase(gameName.split('_').join(' ')),
                        'game_type':toTitleCase(gameType.split('_').join(' ')),
                        'session':toTitleCase(session),
                        'open_pana':myDigits?.open_pana || 'NA',
                        'open_digit':myDigits?.open_digit || 'NA',
                        'close_pana':myDigits?.close_pana || 'NA',
                        'close_digit':myDigits?.close_digit || 'NA',
                        'points_action':key.points,
                    }
      
      
                    try {
                      // Send POST request
                      array[index].error='LOADING...';
                        setRows([...array]);
                           const response = await axios.post(
                              `${API_BASE_URL}set_bid_new.php`, // Replace with your PHP endpoint
                              new URLSearchParams({
                                bids: JSON.stringify([dataObject]), // Convert bids array/object to a JSON string
                              }),
                              {
                                headers: {
                                  "Content-Type": "application/x-www-form-urlencoded",
                                },
                              }
                            );
                     
                      if(response.data.success && response.data.success!=='0'){
                             array[index].error='Success';
                             setRows([...array]);
                              remain_ammount=response.data?.Remaining_user_balance || false; 
                              if(response.data?.Remaining_user_balance===0){
                                  userAccountZero=true;
                                  
                              } 
                                                
                      }else{
                          let errorss=response?.data?.msg || 'Failed';
                          array[index].error=errorss;
                          setRows([...array]);
                      isError=true;
      
                      }
                    } catch (error) {
                      array[index].error='Failed !!';
                      setRows([...array]);
                      isError=true;
      
                    }finally{
                      dispatch(loaderActionSlice(false));
                    }
      
                  }, Promise.resolve());        
                  
                if(remain_ammount || userAccountZero){
                   dispatch(update_user_bal(userAccountZero?0:remain_ammount));
                  if(!isError)navigate('/my-bid');
                }
          };
    


      const obj={
        single_digit:[1,2,3,4,5,6,7,8,9,0],
        jodi_digit: [
            "00", "01", "02", "03", "04", "05", "06", "07", "08", "09",
            "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
            "20", "21", "22", "23", "24", "25", "26", "27", "28", "29",
            "30", "31", "32", "33", "34", "35", "36", "37", "38", "39",
            "40", "41", "42", "43", "44", "45", "46", "47", "48", "49",
            "50", "51", "52", "53", "54", "55", "56", "57", "58", "59",
            "60", "61", "62", "63", "64", "65", "66", "67", "68", "69",
            "70", "71", "72", "73", "74", "75", "76", "77", "78", "79",
            "80", "81", "82", "83", "84", "85", "86", "87", "88", "89",
            "90", "91", "92", "93", "94", "95", "96", "97", "98", "99"
          ],
          single_pana:[
            127, 136, 145, 190, 235, 280, 370, 479, 460, 569, 389, 578,
            128, 137, 146, 236, 245, 290, 380, 470, 489, 560, 678, 579,
            129, 138, 147, 156, 237, 246, 345, 390, 480, 570, 679, 589,
            120, 139, 148, 157, 238, 247, 256, 346, 490, 580, 670, 689,
            130, 149, 158, 167, 239, 248, 257, 347, 356, 590, 680, 789,
            140, 159, 168, 230, 249, 258, 267, 348, 357, 456, 690, 780,
            123, 150, 169, 178, 240, 259, 268, 349, 358, 457, 367, 790,
            124, 160, 179, 250, 269, 278, 340, 359, 368, 458, 467, 890,
            125, 134, 170, 189, 260, 279, 350, 369, 378, 459, 567, 468,
            126, 135, 180, 234, 270, 289, 360, 379, 450, 469, 478, 568
          ],
          double_pana: [
            550, 668, 244, 299, 226, 488, 677, 118, 334,
            100, 119, 155, 227, 335, 344, 399, 588, 669,
            200, 110, 228, 255, 336, 499, 660, 688, 778,
            300, 166, 229, 337, 355, 445, 599, 779, 788,
            400, 112, 220, 266, 338, 446, 455, 699, 770,
            500, 113, 122, 177, 339, 366, 447, 799, 889,
            600, 114, 277, 330, 448, 466, 556, 880, 899,
            700, 115, 133, 188, 223, 377, 449, 557, 566,
            800, 116, 224, 233, 288, 440, 477, 558, 990,
            900, 117, 144, 199, 225, 388, 559, 577, 667
          ],
          triple_pana:['000',111,222,333,444,555,666,777,888,999],


    }
    // Array for points
    const digits =obj[gameType]; // Digits 0-9

    const handlePointClick = (point,type) => {
        if(type==='number'){
            const userExists = digits.find(val => parseInt(val) === parseInt(point));
            if(digits[0].toString().length < point.toString().length || (digits[0].toString().length === point.toString().length && userExists===undefined)){
                dispatch(msgPromtsuccess({msg:`Please enter a valid Number.`,error:true}));
                return false;
            }
                   setGameNumber(point);
            
        }else{
        setSelectedPoint(point);
        }
      };
    
      const openModal = () => {
          if(rows.length){
          setIsModalOpen(true);
          }else{
              dispatch(msgPromtsuccess({msg:`Please Select Bids for Betting.`,error:true}));
          }
        };

        const handleAdd = () => {
            let object_val={
             sangam:gameNumber,
             points:selectedPoint,
             error:'HOLD'
            }
            const userExists = digits.find(val => parseInt(val) === parseInt(gameNumber));

            if(userExists===undefined || digits[0].toString().length !== gameNumber.toString().length  ){
                dispatch(msgPromtsuccess({msg:`Please enter a valid Number.`,error:true}));
                return false
            }
            if(selectedPoint<10){
                dispatch(msgPromtsuccess({msg:`Please Enter minimum 10 Points.`,error:true}));
                return false
            }

            setRows([...rows,object_val]);
           };
           
      return (
        <div className="all_bids" style={{backgroundColor:'#ffffff'}}>
          <div className="header" style={{justifyContent:'space-between'}}>
          <input style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="text" value={formattedDate} className="date-input" readOnly />
          <select style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} className="dropdown" id={session} onChange={(event)=>{setSession(event.target.value);}}>
           {
             Object.entries(sessionval).map(([key, value]) => (
                <option value={key}>{value}</option>
            ))}
          </select>
        </div>
        <div className="points-section" style={{textAlign:'left',paddingLeft:'6%'}}>
          <input placeholder={gameType.split('_').join(' ')} value={gameNumber} style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="number" onChange={(e)=>handlePointClick(e.target.value,'number')} className="date-input" />
          <input placeholder="Enter points" value={selectedPoint}style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="number" onChange={(e)=>handlePointClick(e.target.value,'points')} className="date-input" />
          
        </div>
         
          <div className="add_body" style={{textAlign:'right',paddingRight:'8%'}}>
            <button className="continue-button" style={{width:'39%'}}  onClick={handleAdd}>
              ADD BID
            </button>
          </div>
          <div className="bids_table_div" style={{maxHeight:'300px',overflowY:'auto'}}>
            <div className="table_header_bid">
                <div>Pana</div>
                <div>Points</div>
                <div>Game Type</div>
                <div>Action</div>
            </div><br/>
            {rows.map((bid, index) => (
            <div className="table_content_bid" key={index}>
                <div>{bid.sangam}</div>
                <div>{bid.points}</div>
                <div style={{color:'#3fdd3f'}}>{session}</div>
                <div onClick={() => handleDelete(index)} style={{cursor:'pointer'}}>
                 <IconWithRoundedBorder boxColor={'#BDBDBD'} innerColor={'#007bff'} outerColor={'#007bff'} FonCompo={<FontAwesomeIcon icon={faClose} color="white" size='1x'/>} />
                </div>
            </div>
           ))}
          </div><br/>
          <div className="button_container">
          <div className="footerBid" >
            <span className="footerBid_span">{rows.length}</span>
            <span style={{color:'gray'}}>Bids</span>
          </div>
          <div className="footerBid">
            <span className="footerBid_span">{rows.reduce((acc, value) => acc + parseInt(value.points), 0)}</span>
            <span style={{color:'gray'}}>Points</span>
          </div>
              <button  style={{width:'40%'}}  className="continue-button" onClick={openModal}>
            Submit BID
          </button>
        </div>
        <ModalPopupSingle 
         isOpen={isModalOpen}
         closeModal={closeModal} 
         betData={rows} 
         session={'Open'}
         gameName={gameName}
         handleSubmit={handleSubmit}
         myBidsErrors={{}}
         /> <br/><br/><br/><br/>
        </div>
      );
};


export default SingleGame;
